import DeckRoadwayEditor from "./DeckRoadwayEditor";

export default function DeckRoadwayWindow({riverStation}) {
    return (
        <>
            <div style={{display: 'flex', alignItems: 'center', gap: 16}}>
                {
                    riverStation?.deck_dist_data?.base ? (
                        <DeckRoadwayEditor
                            windowName={'deck-base'}
                            data={riverStation?.deck_dist_data?.base}
                            title={riverStation?.deck_dist_data?.base_title}
                        />
                    ) : (<></>)
                }
                {
                    riverStation?.deck_dist_data?.cmp ? (
                        <DeckRoadwayEditor
                            windowName={'deck-cmp'}
                            targetWindow={'deck-base'}
                            data={riverStation?.deck_dist_data?.cmp}
                            title={riverStation?.deck_dist_data?.compare_title}
                        />
                    ) : (<></>)
                }
            </div>
        </>
    )
}